﻿/* 
Object:         Enum Module 
Used in:        Every Module 
*/

window.timeIntervalEnum = {};

Object.defineProperties(window.timeIntervalEnum, {
    NextMonth       : { value: -5, writable: false },
    NextWeek        : { value: -4, writable: false },
    None            : { value:  0, writable: false },
    QuarterOfHour   : { value:  1, writable: false },
    Hour            : { value:  2, writable: false },
    Day             : { value:  3, writable: false },
    Week            : { value:  4, writable: false },
    Month           : { value:  5, writable: false },
    QuarterOfYear   : { value:  6, writable: false },
    HalfYear        : { value: 10, writable: false },
    Year            : { value: 11, writable: false },
    AskedPeriod     : { value: 12, writable: false },
    Minute          : { value: 13, writable: false },
    FiveMinutes     : { value: 14, writable: false },
    Seconds         : { value: 15, writable: false }

});

Object.freeze(window.timeIntervalEnum);